import Pusher from 'pusher-js'
import { getEnv, isLocal } from '../helpers/functions'

Pusher.logToConsole = isLocal()

let pusher: Pusher | null = null

export const getPusher = (): Pusher => {
    if (!pusher) {
        pusher = new Pusher(<string>getEnv('REACT_APP_PUSHER_APP_KEY'), {
            authEndpoint: `${getEnv('REACT_APP_API_HOSTNAME')}/api/broadcasting/auth`,
            auth: {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('api_token')}`,
                    Accept: 'application/json',
                },
            },
            cluster: getEnv('REACT_APP_PUSHER_APP_CLUSTER'),
            forceTLS: true,
        })
    }

    return pusher
}
